import { IColumn } from '../types';
import { defaultHeaderRenderer } from '../headers';
import { CellEventsHandler } from '../formatters';
import { CellProps } from '../../types';
import { useTranslation } from "react-i18next";

const ImmigrationProvidersFormatter = (cellProps: CellProps) => {
    const { t } = useTranslation('common');
  if (!cellProps.row?.immigrationProviders?.length) {
    return <CellEventsHandler cellProps={cellProps}>{t('common:none')}</CellEventsHandler>;
  }
  return <CellEventsHandler cellProps={cellProps}>{cellProps.row.immigrationProviders.join(', ')}</CellEventsHandler>;
};

export const ImmigrationProvidersColumn = (): IColumn => ({
  item: {
    key: 'immigrationProviders',
    name: 'Immigration',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    width: 'minmax(112px, 1fr)',
    formatter: ImmigrationProvidersFormatter,
  },
  visible: ({ isImmigrationProvidersVisible }) => isImmigrationProvidersVisible!,
});
